"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
/**
 * Surface that display content and actions on a single topic.
 * @param children - React node containing the card main content.
 * @param style - Card custom styles (optional).
 * @param header - Card header (optional).
 * @param className - Styles classname (optional).
 * @param as - React element type with the card want to by defined as (optional).
 * Default: aside.
 */
function Card(_a) {
    var children = _a.children, header = _a.header, props = __rest(_a, ["children", "header"]);
    return (react_1.default.createElement(styles_1.CardContainer, __assign({}, props),
        header &&
            (typeof header === "string" ? (react_1.default.createElement(styles_1.CardHeader, null, header)) : (header)),
        children));
}
exports.default = Card;
//# sourceMappingURL=index.js.map